import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';

import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import { AI_TOOLS, DOCUMENT_SELECTION_MODES } from '@constants';
import { Body5, Container, H5, Page } from '@ui';
import ChatQueryTool from '@features/chat/ChatQueryTool';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.AGENT_CHAT_QUERY;

function AgentChatDigitalAnalyst() {
  const navigate = useNavigate();

  const [docSelectModes] = React.useState([DOCUMENT_SELECTION_MODES.allCompany, DOCUMENT_SELECTION_MODES.myDocs]);
  const [defaultActiveDocSelectMode] = React.useState(DOCUMENT_SELECTION_MODES.allCompany);

  const [pageError, setPageError] = React.useState(null);

  const onGoBack = () => navigate(ROUTES.home);

  const onPageError = (error) => {
    setPageError(error);
  };

  React.useEffect(() => {
    scrollToTop();
  }, []);

  if (pageError) {
    return (
      <PageWrapper>
        <Header />
        <Body withFooter>
          <Page width={'1000px'}>
            <H5>Digital Analyst Chat</H5>
            <Container top={24} bottom={400}>
              <Body5>Something went wrong, refresh the page and try again.</Body5>
            </Container>
          </Page>
        </Body>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <ChatQueryTool
          heading="Digital Analyst Chat"
          onGoBack={onGoBack}
          tool={tool}
          onPageError={onPageError}
          docSelectModes={docSelectModes}
          defaultActiveDocSelectMode={defaultActiveDocSelectMode}
        />
      </Body>
    </PageWrapper>
  );
}

export default AgentChatDigitalAnalyst;
